// Registers every Iconify icon the site uses from bundled data, so
// <Icon icon="set:name" /> never requests api.iconify.design.
//
// Data: src/data/iconify-icons.json is an array of IconifyJSON collections
// (one per prefix: { prefix, width?, height?, icons: { name: { body, ... } } }),
// extracted from the @iconify-json/<prefix> npm packages. Only the icons used
// in src/ are included. When you add a new <Icon icon="set:name" />, add that
// icon to the JSON too, otherwise it is fetched from the Iconify API again.
import { addCollection } from "@iconify/react";
import collections from "../data/iconify-icons.json";

collections.forEach((collection) => {
  addCollection(collection);
});
